export const numFieldError = 'Поле должно содержать только цифры';
export const lenFieldError = (length) =>
  `Поле должно содержать ${length} символов`;
// export const minFieldError = (length) =>
//   `Поле должно содержать более ${length} символов`;
export const maxFieldError = (length) =>
  `Поле не может содержать более ${length} символов`;

export const numFieldValidator = (_rule, value, callback) => {
  const regEx = /^\d+$/;
  if (value && !regEx.test(value)) {
    callback('Поле должно содержать только цифры');
  } else {
    callback();
  }
};

export const innFieldValidator = (_rule, value, callback) => {
  const regEx = /^\d{10}$|^\d{12}$/;
  if (value && !regEx.test(value)) {
    callback(lenFieldError('10 или 12'));
  } else {
    callback();
  }
};

export const kppFieldValidator = (_rule, value, callback) => {
  const regEx = /^\d{9}$/;
  if (value && !regEx.test(value)) {
    callback(lenFieldError(9));
  } else {
    callback();
  }
};
